var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Save50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3498db",
    d: "M42 42L6 42 6 6 37 6 42 11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39,39c0,0.553-0.447,1-1,1H10c-0.553,0-1-0.447-1-1V25c0-0.553,0.447-1,1-1h28c0.553,0,1,0.447,1,1 V39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M13 31H35V33H13zM13 27H35V29H13zM13 35H35V37H13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2980b9",
    d: "M9,6v10c0,1.104,0.896,2,2,2h15c1.104,0,2-0.896,2-2V6H9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M15,6v10c0,1.104,0.896,2,2,2h15c1.104,0,2-0.896,2-2V6H15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M26 8H30V16H26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Save50);
export default __webpack_public_path__ + "static/media/icons8-save-50.11da186138a05cb34b800a8a76e6e08e.svg";
export { ForwardRef as ReactComponent };